import {
  ChangeDetectionStrategy,
  Component,
  inject,
  LOCALE_ID
} from '@angular/core';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { TippyDirective } from '@ngneat/helipopper';

import { GAME_CARDS } from '@app/modules/main/constants';

@Component({
  selector: 'shell-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLinkActive,
    RouterLink,
    TippyDirective
  ]
})
export class NavbarComponent {
  public readonly GAME_CARDS = GAME_CARDS;
  
  public readonly isRuLanguage = 'ru' === inject(LOCALE_ID);
}
